function columns(){
    if(jQuery('.block.columns .has-filter')){
        var $grid = jQuery('.block.columns .has-filter').isotope({
            itemSelector: '.single-block',
            percentPosition: true
        });

        $grid.imagesLoaded().progress( function() {
            $grid.isotope('layout');
        });

        jQuery('.project-filter').click(function() {
            jQuery('.project-filter').removeClass('active');
            jQuery(this).addClass('active');
            var filterValue = jQuery( this ).attr('data-filter');
            $grid.isotope({ filter: filterValue });
            $grid.isotope('shuffle');
        });

        jQuery('select.project-filter-select').on('change', function() {
            $grid.isotope({ filter: this.value });
            $grid.isotope('shuffle');
        });

        if(jQuery('.projects-small').is(':last-child')){
            jQuery('.projects-small').css('padding-bottom', '0px');
        }
    }
}
